import { idealTextColor } from 'utils';

import {
  CLUSTER_FADE_OUT_END_ZOOM,
  CLUSTER_FADE_OUT_START_ZOOM,
} from './constants';

const clusterOpacity = [
  'interpolate',
  ['linear'],
  ['zoom'],
  CLUSTER_FADE_OUT_START_ZOOM, 0.9,
  CLUSTER_FADE_OUT_END_ZOOM, 0,
];

export const heatmapClusterLayer = color => ({
  id: 'heatmap-clusters',
  type: 'circle',
  filter: ['has', 'point_count'],
  paint: {
    'circle-color': color,
    'circle-opacity': clusterOpacity,
    'circle-stroke-color': 'rgba(255,255,255,0.9)',
    'circle-stroke-width': 1.5,
    'circle-radius': [
      'step',
      ['get', 'point_count'],
      16,
      10, 20,
      50, 26,
      200, 34,
    ],
  },
});

export const heatmapClusterCountLayer = color => ({
  id: 'heatmap-cluster-count',
  type: 'symbol',
  filter: ['has', 'point_count'],
  layout: {
    'text-field': '{point_count_abbreviated}',
    'text-size': 12,
  },
  paint: {
    'text-color': idealTextColor(color),
    'text-opacity': clusterOpacity,
  },
});
